export default class APIPersonDomainService {
    static fromJSON(json) {
        return Object.assign(Object.assign({}, json), { orientationCompleteDate: new Date(json.orientationCompleteDate), fullName: `${json.firstName || ""} ${json.lastName || ""}`.trim(), 
            // @ts-expect-error - TS2322 - Type '{ orientationCompleteDate: Date; fullName: string; personId: any; }' is not assignable to type 'APIPerson'.
            personId: json.id });
    }
}
